import { Link } from 'react-router-dom';
import { ArrowRightIcon, FireIcon } from '@heroicons/react/24/outline';
import { HomeLazySection } from '../HomeLazySection';
import { homeCta } from '../homeCtaStyles';
import { HOME_DROP_STEPS } from '../homeContent';

export function HomeDropsWorkSection() {
  return (
    <HomeLazySection
      className="py-10 md:py-12 bg-gradient-to-b from-white via-[#fbfaff] to-white"
      placeholderMinHeight="280px"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="home-drops-work relative overflow-hidden rounded-[28px] border border-purple-100/80 bg-gradient-to-br from-[#f4f0ff] via-white to-[#fef6ff] p-5 shadow-sm md:p-7">
          <div
            className="pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full bg-purple-200/35 blur-3xl"
            aria-hidden
          />

          <div className="relative flex flex-col gap-5 md:gap-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="max-w-lg">
                <p className="inline-flex items-center gap-1.5 rounded-full border border-purple-100 bg-white/90 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-purple-700">
                  <FireIcon className="h-3.5 w-3.5 text-orange-500" />
                  How drops work
                </p>
                <h2 className="mt-3 text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
                  Limited runs.{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#3B3B98] to-[#9B59B6]">
                    No mass merch.
                  </span>
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  Three steps—release, grab, deliver. Small batches so your piece stays rare.
                </p>
              </div>

              <Link
                to="/shop"
                className={`${homeCta.primary} w-full shrink-0 sm:mt-1 sm:w-auto !px-5 !py-2.5 !text-sm`}
              >
                Shop drops
                <ArrowRightIcon className="ml-1.5 h-4 w-4" />
              </Link>
            </div>

            <ol className="home-drops-timeline grid grid-cols-1 gap-0 sm:grid-cols-3 sm:gap-3">
              {HOME_DROP_STEPS.map((step, index) => {
                const Icon = step.icon;
                const isLast = index === HOME_DROP_STEPS.length - 1;

                return (
                  <li
                    key={step.step}
                    className={`home-drops-timeline__step flex gap-3 sm:flex-col sm:gap-2 ${isLast ? '' : 'pb-4 sm:pb-0'}`}
                  >
                    <div className="flex flex-col items-center sm:flex-row sm:items-start sm:justify-between">
                      <span className="home-drops-timeline__node flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-purple-100/80 bg-white shadow-sm">
                        <Icon className="h-4 w-4 text-indigo-700" aria-hidden />
                      </span>
                      {!isLast ? (
                        <span className="home-drops-timeline__line flex-1 sm:hidden" aria-hidden />
                      ) : null}
                      <span className="mt-2 hidden text-[10px] font-extrabold uppercase tracking-wider text-purple-600 sm:mt-0 sm:block">
                        {step.step}
                      </span>
                    </div>

                    <div className="min-w-0 flex-1 pt-0.5 sm:pt-0">
                      <p className="text-[10px] font-extrabold uppercase tracking-wider text-purple-600 sm:hidden">
                        Step {step.step}
                      </p>
                      <p className="text-sm font-extrabold leading-snug text-slate-900">
                        {step.title}
                      </p>
                      <p className="mt-1 text-xs leading-relaxed text-slate-600 line-clamp-2 sm:line-clamp-none">
                        {step.body}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ol>

            <div className="flex flex-col items-start gap-2 border-t border-purple-100/60 pt-4 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-xs text-slate-500">
                Miss a drop?{' '}
                <span className="font-semibold text-slate-700">It may not come back.</span>
              </p>
              <Link
                to="#drops-rail"
                className={`${homeCta.ghost} inline-flex items-center gap-1 text-sm`}
              >
                See style picks
                <ArrowRightIcon className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </HomeLazySection>
  );
}
